module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en-us":{"encodingError":{"inline":"Your message can {boldText}. Your message currently has unsupported characters (i.e., emojis, special characters, hidden characters, images, GIFs, etc.). This may be the result of copy-pasting. If the problem persists, try re-typing your message manually.","boldText":"only contain letters and numbers","learnMore":"Learn more"}}}')
  delete Component.options._Ctor
}
